<div class="notification-details-popup">
  <div class="w-full flex justify-end notification-close-section">
    <app-icon
      (click)="closeNotification(false)"
      class="cursor-pointer close-icon"
      svgIcon="cross"></app-icon>
  </div>
  <div class="notification-details-section">
    <div class="notification-heading-section">
      Are you sure you want to navigate, changes made to current page will be
      lost
    </div>
    <div class="notification-action-section flex justify-center">
      <div class="w-[50%] flex justify-between">
        <app-primary-button (handleClick)="closeNotification(false)"
                            [type]="'small'"
                            class="w-[48%]"> Cancel
        </app-primary-button>
        <app-primary-button (handleClick)="closeNotification(true)"
                            [type]="'small'"
                            class="w-[48%]"> Ok
        </app-primary-button>
      </div>
    </div>
  </div>
</div>
